import { Box, Tab, Tabs } from '@mui/material'

import LinkChild from '@src/lib/LinkChild'

import campaignContentPaths from './campaignContentPaths'
import industryContentPaths from './industryContentPaths'
export interface TabProps {
  label?: string | React.ReactNode
  value: string
  to?: string
}
export interface ContentTabsProps {
  paths?: typeof campaignContentPaths | typeof industryContentPaths
  selectedTab?: string
  onTabChange?: (tab: string) => void
  tabs: TabProps[]
}

const ContentTabs: React.FC<React.PropsWithChildren<ContentTabsProps>> = ({
  paths,
  selectedTab = 'organic',
  tabs,
  ...rest
}) => {
  return (
    <>
      <Box boxShadow={1} bgcolor={(theme) => theme.palette.grey[200]}>
        <Tabs {...rest} value={selectedTab}>
          {tabs.map((tab: TabProps) => (
            <LinkChild
              key={tab.value}
              to={
                tab.to ||
                (paths
                  ? paths.index.build({
                      ...paths.index.useParams(),
                      activeTab: tab.value,
                    })
                  : '')
              }
              value={tab.value}
            >
              <Tab
                label={tab.label || tab.value}
                data-testid={`${tab.value}-tab`}
              />
            </LinkChild>
          ))}
        </Tabs>
      </Box>
    </>
  )
}

export default ContentTabs
